/**
 * Campaign payloads may carry `senderId` as a scalar or as `{ label, value }` (same shape as Select options).
 * @returns {{ id: string|number|null, label: string }}
 */
export function parseCampaignSenderIdField(raw) {
    if (raw === undefined || raw === null || raw === '') {
        return { id: null, label: '' };
    }
    if (typeof raw === 'object') {
        const id = raw.value ?? raw.senderId ?? raw.id;
        const label = raw.label ?? raw.senderEmail ?? '';
        const idNorm = id !== undefined && id !== null && id !== '' ? id : null;
        return {
            id: idNorm,
            label: typeof label === 'string' ? label : '',
        };
    }
    return { id: raw, label: '' };
}

/**
 * Maps provider sender API rows to Select options.
 * Expects `id`, `senderEmail`, `name`, and optional default flag (`isDefault` / `default` / `defaultSender`).
 */
function mapSenderItem(item, index) {
    const id = item.id ?? item.senderId ?? item.value;
    const email = item.senderEmail ?? '';
    const name = item.name ?? '';
    const isDefault = Boolean(item.isDefault ?? item.default ?? item.defaultSender);

    return {
        value: id !== undefined && id !== null ? String(id) : String(index),
        label: email,
        subLabel: name,
        isDefault,
    };
}

export function normalizeMarketingSendersResponse(data) {
    const raw = Array.isArray(data) ? data : (data?.items ?? data?.senders ?? data?.data ?? []);
    return raw.map((item, index) => mapSenderItem(item, index));
}
